<template lang="pug">
#task-form.right-panel.md-elevation-1
  div(v-loader-overlay="progressTaskFormCard")
      .md-layout
        .md-layout-item
          md-button.md-accent.md-dense(v-if="!$route.params.dealid" v-bind:to="{ name: task.id ? 'Task' : 'Tasks', params: { groupid: $route.params.groupid, projectid: $route.params.projectid, taskid: $route.params.taskid }, query: { search: $route.query.search, responsible_id: $route.query.responsible_id, responsible: $route.query.responsible }}") Отмена
          md-button.md-accent.md-dense(v-if="$route.params.dealid && !$route.params.taskid" v-bind:to="{ name: 'DealEdit', params: { dealid: $route.params.dealid } }") Отмена
          md-button.md-accent.md-dense(v-if="$route.params.dealid && $route.params.taskid" v-bind:to="{ name: 'DealTask', params: { dealid: $route.params.dealid, taskid: $route.params.taskid } }") Отмена
        .md-layout-item.md-layout.md-alignment-top-right
          md-button.md-primary.md-dense(@click="saveTask") Сохранить
      md-field(v-bind:class="{ 'md-invalid': errors.has('name') }")
        label Название
        md-input(required v-model="task.name" name="name" v-validate="'required'")
        span.md-error(v-show="errors.has('name')") {{ errors.first('name') }}
      md-field
        label Описание
        md-textarea(v-model="task.description")

      //md-field(v-bind:class="{ 'md-invalid': errors.has('responsible_login'), 'md-has-value': task.responsible_id }")
        label Исполнитель
        md-input(v-model="task.responsible.login" @keyup="getUsers" @focus="getUsers" v-show="!task.responsible_id" v-validate="'required'" name="responsible_login" required)
        span.md-error(v-show="errors.has('responsible_login')") {{ errors.first('responsible_login') }}
        md-chip(v-if="task.responsible_id" md-deletable @md-delete="unsetResponsible") {{ task.responsible.login }}
        md-content.md-elevation-3.users.float-window(v-if="users.length && typeof task.responsible != 'undefined'" md-theme="white")
          md-chip(v-for="user in users" v-bind:key="user.id" @click="setResponsible(user)" md-clickable) {{ user.login }}
      
      autocomplete(
          v-bind:items="users"
          placeholder="Исполнитель"
          label="Исполнитель"
          v-model="task.responsible_id"
          v-bind:showOnFocus="true"
          v-bind:callback="searchUsers"
          v-on:select="selectResponsible"
          display-property="login"
          property="id"
          return="id"
          name="responsible_login"
          id="responsible_login"
      )

      md-field(v-bind:class="{ 'md-invalid': errors.has('deadline'), 'md-has-value': task.deadline }")
        label Крайний срок
        datetime(v-model="task.deadline" input-class="md-input" type="datetime" v-bind:use12-hour="false" v-bind:week-start="1" v-bind:phrases="{ ok: 'Ок', cancel: 'Отмена' }")
        md-button.md-icon-button.md-dense(@click="task.deadline = ''"): md-icon close
        span.md-error(v-show="errors.has('deadline')") {{ errors.first('deadline') }}
      md-field(v-bind:class="{ 'md-invalid': errors.has('project_id') }")
        label Проект
        md-select(v-model="task.project_id" name="project_id")
          md-option(v-for="project in projects" v-bind:value="project.id" v-bind:key="project.id") {{ project.name }}
        span.md-error(v-show="errors.has('project_id')") {{ errors.first('project_id') }}
      md-field(v-bind:class="{ 'md-invalid': errors.has('status_id') }" v-if="task.project_id")
        label Категория
        md-select(v-model="task.status_id" name="status_id")
          md-option(v-for="status in projectStatuses" v-bind:value="status.id" v-bind:key="status.id" v-if="status.project_id == task.project_id") {{ status.name }}
        span.md-error(v-show="errors.has('status_id')") {{ errors.first('status_id') }}
</template>

<script>
import moment from "moment"
import autocomplete from '@/components/autocomplete'
export default {
  components: {autocomplete},
  data() {
    return {
      task: {},
      users: [],
      title: 'Создать задачу',
      coexecutor_login: '',
      date: '',
      projectStatuses: []
    }
  },
  metaInfo() {
    return {
      title: this.title
    }
  },
  computed: {
    progressTaskFormCard() {
      return this.progressObj['load-task-from-card'];
    },
    progressObj() {
      return this.$store.state.progressObj;
    },
    projects() {
      return this.$store.state.tasks.projects
    }
  },
  created() {
    this.getTask();
    this.searchUsers();
    this.$store.commit('openRightPanel');
    this.$validator.localize('ru', {
      attributes: {
        name: 'название',
        responsible_login: 'исполнитель',
        deadline: 'крайний срок'
      }
    });
    if (typeof this.$route.params.taskid !== 'undefined') this.title = 'Изменение задачи';
  },
  methods: {
    //сохранение заявки
    saveTask() {
      let self = this;
      if (!self.task.responsible_id) {
        self.task.responsible.login = '';
        self.users = []
      }
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          this.$store.commit('showProgressBar', 'load-task-from-card');
          //присваиваем полю deadline значние null, т.к. компонент datetime работает со строками, а в бд нельзя записать пустую строку
          if (!self.task.deadline) self.task.deadline = null
          else self.task.deadline = moment(self.task.deadline).format('DD-MM-YYYY HH:mm:00');
          if (typeof this.$route.params.dealid !== 'undefined') self.task.deal_id = this.$route.params.dealid;
          if (!self.task.status) self.task.status = 1; //устанавливаем стандартный статус
          self.$store.dispatch(self.task.id ? 'tasks/updateTask' : 'tasks/addTask', { task: self.task }).then(task => {
            self.$router.push({ name: 'Task', params: { projectid: task.project_id, taskid: task.id }});
            this.$store.commit('hideProgressBar', 'load-task-from-card');
          })
        }
      })
    },
    //получение пользователей
    getUsers() {
      let self = this;
      setTimeout(() => {
        if (self.task.responsible.login.length > 0) {
          this.$store.commit('showProgressBar', 'load-task-from-card');
          self.$store.dispatch('users/searchUsers', {
            filter: {
              model: [
                ['email', '%', self.task.responsible.login], 'or',
                ['login', '%', self.task.responsible.login], 'or',
                ['fio',   '%', self.task.responsible.login]
              ]
            }
          }).then(users => { self.users = users }).finally(() => {
              this.$store.commit('hideProgressBar', 'load-task-from-card');
          });
        } else if (self.coexecutor_login.length > 0) {
          this.$store.commit('showProgressBar', 'load-task-from-card');
          self.$store.dispatch('users/searchUsers', {
            filter: {
              model: [
                ['email', '%', self.coexecutor_login], 'or',
                ['login', '%', self.coexecutor_login], 'or',
                ['fio',   '%', self.coexecutor_login]
              ]
            }
          }).then(users => { self.users = users }).finally(() => {
              this.$store.commit('hideProgressBar', 'load-task-from-card');
          });
        } else {
          self.users = []
        }
      }, 100);
    },
    searchUsers(search) {
      let data = {
        page:       1,
        order_by:   'id',
        order_type: 'asc',
        count:      50,
        filter:     {model: [], relation: []}
      };
      if (search) data.filter.model.push(['login', '%', search]);
      else data.filter.relation.push(['groups', 'code', '=', 'managers']);
      return this.$store.dispatch('users/getUsers', data).then(r => {
        this.users = r;
        return r;
      }).finally(() => this.$store.commit('hideProgressBar', 'load-task-from-card'));
    },
    selectResponsible(value, user) {

    },
    //назначение ответственного
    setResponsible(user) {
      this.users = [];
      this.task.responsible = user;
      this.task.responsible_id = user.id;
    },
    //удаление ответственного
    unsetResponsible() {
      this.task.responsible = { login: '' };
      this.task.responsible_id = null;
    },
    //получение заявки
    getTask() {
      this.task = {
        name: '',
        description: '',
        parent_task_id: null,
        taskmaster_id: this.$store.state.users.current.id,
        responsible_id: null,
        project_id: this.$route.params.projectid !== 'all' ?  this.$route.params.projectid : null,
        type: 1,
        id: null,
        deadline: '',
        responsible: {
          login: ''
        }
      };
      let self = this;
      if (typeof this.$route.params.taskid !== 'undefined') {
        this.$store.commit('showProgressBar', 'load-task-from-card');
        this.$store.dispatch('tasks/getTask').then(() => {
          if (this.$store.state.tasks.task.deadline == null) this.$store.state.tasks.task.deadline = '';
          self.task = this.$store.state.tasks.task;
          this.$store.dispatch('tasks/getProjectStatuses', { return: true, project_id: null }).then(projectStatuses => {
            this.projectStatuses = projectStatuses;
            this.$store.commit('hideProgressBar', 'load-task-from-card');
          })
        })
      }
    }
  },
  watch: {
    '$route.path'() {
      this.$store.commit('openRightPanel')
      this.getTask()
    },
    'task.project_id'() {
      this.task.status_id = null;
      this.$store.dispatch('tasks/getProjectStatuses', { return: true, project_id: null }).then(projectStatuses => {
        this.projectStatuses = projectStatuses
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// TaskForm.vue?0a1058fd